import { Card } from "@mui/material";
import styled from "styled-components";

const StyledMiddleCard = styled(Card)(({ theme }) => ({
  maxWidth: 600,
  margin: '20px auto',
  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  borderRadius: 10,
  backgroundColor: 'white',
  padding: theme.spacing(6),
}));

export default StyledMiddleCard;